import React from 'react';
import { Button } from './Button';
interface Tomo {
  num: string;
  icon: string;
  title: string;
  desc: string;
}
export function ProductShowcase() {
  const tomos: Tomo[] = [{
    num: '01',
    icon: '📘',
    title: 'Introducción a la Acuicultura',
    desc: 'Historia, sistemas, especies, recursos hídricos y perfil del técnico. Donde el alumno que nunca vio un estanque entiende por qué la acuicultura importa.'
  }, {
    num: '02',
    icon: '📗',
    title: 'Calidad del Agua y Ecosistemas',
    desc: 'Los 10 parámetros esenciales, el ciclo del nitrógeno, sistemas de filtración y monitoreo sistemático.'
  }, {
    num: '03',
    icon: '📙',
    title: 'Piscicultura y Especies Comerciales',
    desc: 'Tilapia, trucha, pacú, sábalo, camarón y especies nativas. Fichas técnicas completas y estrategias de comercialización.'
  }, {
    num: '04',
    icon: '📕',
    title: 'Alimentación y Nutrición Acuícola',
    desc: 'FCR, tablas de alimentación por especie y temperatura, formulación básica de dietas y proteínas alternativas.'
  }, {
    num: '05',
    icon: '📓',
    title: 'Sanidad y Manejo Productivo',
    desc: 'Bioseguridad, enfermedades bacterianas, virales y parasitarias, BPA, uso responsable de medicamentos y seguridad laboral.'
  }, {
    num: '06',
    icon: '📔',
    title: 'Sustentabilidad e Innovación',
    desc: 'RAS, Biofloc, Acuaponía, IoT, IA, economía circular, cambio climático y visión estratégica del sector.'
  }];
  return <section className="py-7 px-4 bg-brand-cream" data-id="element-140">
      <div className="max-w-5xl mx-auto" data-id="element-141">
        <div className="text-center mb-5" data-id="element-142">
          <p className="text-brand-green font-display font-bold uppercase tracking-widest text-sm mb-1" data-id="element-143">
            Los 6 Tomos Maestros
          </p>
          <h2 className="text-2xl md:text-4xl font-display font-bold text-brand-navy uppercase leading-tight" data-id="element-144">
            <span className="green-highlight" data-id="element-145">500+ páginas</span> de material
            técnico aplicado
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3" data-id="element-146">
          {tomos.map((t, i) => <div key={i} className="brunson-card rounded-lg p-3 md:p-4 flex gap-3 hover:translate-y-[-2px] transition-transform" data-id="element-147">
              <div className="shrink-0" data-id="element-148">
                <div className="w-14 h-14 md:w-16 md:h-16 bg-brand-navy text-white rounded-lg flex flex-col items-center justify-center font-display font-bold border-b-4 border-brand-green" data-id="element-149">
                  <span className="text-[9px] uppercase tracking-widest leading-none" data-id="element-150">
                    Tomo
                  </span>
                  <span className="text-2xl leading-none mt-0.5" data-id="element-151">{t.num}</span>
                </div>
              </div>
              <div className="flex-1" data-id="element-152">
                <h3 className="font-display font-bold text-brand-navy text-base md:text-lg uppercase leading-tight mb-1" data-id="element-153">
                  {t.icon} {t.title}
                </h3>
                <p className="text-xs md:text-sm text-brand-mute leading-snug font-medium" data-id="element-154">
                  {t.desc}
                </p>
              </div>
            </div>)}
        </div>

        <div className="max-w-md mx-auto mt-5" data-id="element-155">
          <Button data-id="element-156">🚀 Sí, Quiero el Sistema Acuicultura Pro</Button>
        </div>
      </div>
    </section>;
}